import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useAppDispatch } from "@common/store/hooks";
import { applyHashTokens } from "@common/store/slices/authSlice";
import { POST_LOGIN_PATH_KEY } from "@common/constants";

// Catches the #access_token=…&id_token=…&refresh_token=… hash that
// login.kast-dev.net posts back after sign-in, then returns the user to
// wherever redirectToLogin sent them from.
export default function HashTokenHandler() {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const handled = useRef(false);

  useEffect(() => {
    if (handled.current) return;
    const hash = window.location.hash;
    if (!hash || !hash.includes("access_token")) return;
    handled.current = true;

    dispatch(applyHashTokens())
      .unwrap()
      .then(() => {
        let dest = "/";
        try {
          const saved = sessionStorage.getItem(POST_LOGIN_PATH_KEY);
          if (saved && saved.startsWith("/")) dest = saved;
          sessionStorage.removeItem(POST_LOGIN_PATH_KEY);
        } catch {
          /* ignore */
        }
        // The player is entered by full page loads only: it is the one
        // cross-origin-isolated page (AGENTS.md).
        if (dest === "/play" || dest.startsWith("/play?")) window.location.replace(dest);
        else navigate(dest, { replace: true });
      })
      .catch(() => {
        /* leave the user where they are */
      });
  }, [dispatch, navigate]);

  return null;
}
